import { render, staticRenderFns } from "./incl-comments.vue?vue&type=template&id=335f8155&scoped=true"
import script from "./incl-comments.vue?vue&type=script&lang=js"
export * from "./incl-comments.vue?vue&type=script&lang=js"
import style0 from "./incl-comments.vue?vue&type=style&index=0&id=335f8155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f8155",
  null
  
)

export default component.exports